<template>
  <WdsAlert :error="!compliance.completed" :data-test="`compliance-status-${compliance.name}`">
    <WdsStack gap-sm align-center class="tw-flex-wrap lg:tw-flex-nowrap tw-justify-between">
      <WdsStack gap-sm align-start class="tw-flex-1">
        <WdsStack align-start>
          <WdsIcon :name="WdsIconNameEnum.WARNING" :size="20" weight="thin" class="tw-mt-0.5" />
        </WdsStack>

        <WdsStack direction-column>
          <WdsText large>
            <span class="tw-text-red-600">{{ $t(title) }}</span>
          </WdsText>

          <WdsText>
            <span class="tw-text-gray-800 tw-whitespace-pre-line">{{ $t(description) }}</span>
          </WdsText>
        </WdsStack>
      </WdsStack>
    </WdsStack>
  </WdsAlert>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAlert, WdsIcon, WdsIconNameEnum, WdsStack, WdsText } from '@worksome/wds-components'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

defineProps<{
  compliance: { name: string; title?: string; description?: string; completed?: boolean }
  hireId: string
}>()

const title = computed(() => $t('Background Checks In Progress'))

const description = computed(() =>
  $t(
    'Your background checks have been initiated. You will be notified once they are complete and the contract is ready for signature. Your start date may be adjusted based on the completion of the background checks.',
  ),
)
</script>
